import { gql } from "@/apis/nannyml";

export const verifyAuth = gql(/* GraphQL */ `
  query VerifyAuth($authSettings: AuthenticationSettingsInput!, $accessToken: String!) {
    verify_auth(authSettings: $authSettings, accessToken: $accessToken)
  }
`);
